/* Cart page - Element Packaging, W-68, 10 October 2026. Used by sections/el-cart.liquid.
   Quantity steppers, remove, add-on Add and the PO note talk to the Shopify Cart AJAX API and ask for the
   cart section back (Section Rendering API), then swap only the [data-el-region] parts so the express checkout
   buttons (rendered once by Shopify) are left alone. The header basket count is updated from the cart.
   The data-el-add / data-el-step / data-el-qty names are shared with assets/el-card.js (document listeners), so
   handled events stop at the cart root. */
(function () {
  var root = document.querySelector('[data-el-cart]');
  if (!root) return;
  var sectionId = root.getAttribute('data-section-id');
  var busy = false;
  var timers = {};

  function json(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) { throw d; } return d; });
    });
  }

  function showError(msg) {
    var el = root.querySelector('[data-el-error]');
    if (!el) return;
    if (!msg) { el.hidden = true; el.textContent = ''; return; }
    el.textContent = msg;
    el.hidden = false;
  }

  function setCount(n) {
    document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
      el.setAttribute('data-header-cart-count', n > 0 ? String(n) : '');
      el.classList.toggle('visible', n > 0);
    });
  }

  function apply(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-el-cart]');
    if (!fresh) { location.reload(); return; }
    var count = parseInt(fresh.getAttribute('data-count'), 10) || 0;
    var hadItems = (parseInt(root.getAttribute('data-count'), 10) || 0) > 0;
    if (count === 0 || !hadItems) { location.reload(); return; }
    root.setAttribute('data-count', count);
    fresh.querySelectorAll('[data-el-region]').forEach(function (node) {
      var name = node.getAttribute('data-el-region');
      var cur = root.querySelector('[data-el-region="' + name + '"]');
      if (cur) cur.innerHTML = node.innerHTML;
    });
    setCount(count);
    document.dispatchEvent(new CustomEvent('el:cart-updated', { detail: { count: count } }));
  }

  function render() {
    return fetch('/cart?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) { if (s && s[sectionId]) apply(s[sectionId]); });
  }

  function run(promise) {
    busy = true;
    root.classList.add('is-busy');
    showError('');
    return promise
      .then(function (res) {
        if (res && res.sections && res.sections[sectionId]) { apply(res.sections[sectionId]); return; }
        return render();
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Sorry, the basket could not be updated. Please try again.';
        showError(msg);
        return render();
      })
      .then(function () { busy = false; root.classList.remove('is-busy'); });
  }

  function change(line, qty) {
    return run(json('/cart/change.js', { line: line, quantity: qty, sections: [sectionId], sections_url: '/cart' }));
  }

  root.addEventListener('click', function (e) {
    var step = e.target.closest('.el-cart__qty [data-el-step]');
    var rem = e.target.closest('.el-cart__remove');
    var add = e.target.closest('.el-cart__add[data-el-add]');
    if (step || rem || add) { e.stopPropagation(); }
    if (step || rem) {
      var item = e.target.closest('[data-line]');
      if (!item || busy) return;
      var line = parseInt(item.getAttribute('data-line'), 10);
      var input = item.querySelector('[data-el-qty]');
      var qty = rem ? 0 : Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-el-step'), 10));
      if (input) input.value = qty;
      change(line, qty);
    } else if (add) {
      if (busy) return;
      add.disabled = true;
      add.textContent = 'Adding';
      run(json('/cart/add.js', { items: [{ id: parseInt(add.getAttribute('data-el-add'), 10), quantity: 1 }], sections: [sectionId], sections_url: '/cart' }));
    }
  });

  root.addEventListener('change', function (e) {
    var input = e.target.closest('.el-cart__qty [data-el-qty]');
    if (input) {
      e.stopPropagation();
      var item = input.closest('[data-line]');
      var line = parseInt(item.getAttribute('data-line'), 10);
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      clearTimeout(timers[line]);
      timers[line] = setTimeout(function () { change(line, qty); }, 250);
      return;
    }
    var note = e.target.closest('[data-el-note]');
    if (note) {
      json('/cart/update.js', { note: note.value }).catch(function () {});
    }
  });

  root.addEventListener('input', function (e) {
    if (e.target.matches('.el-cart__qty [data-el-qty]')) e.stopPropagation();
  });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('.el-cart__qty [data-el-qty]')) {
      e.preventDefault();
      e.stopPropagation();
      e.target.blur();
    }
  });
})();
